export default __webpack_public_path__ + "vision-overview-header-image-1200-365397819a395e40476789276cda906d.png";